import { render, staticRenderFns } from "./CustomerTabsTravel.vue?vue&type=template&id=1bb79840&scoped=true&"
import script from "./CustomerTabsTravel.vue?vue&type=script&lang=js&"
export * from "./CustomerTabsTravel.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTabsTravel.vue?vue&type=style&index=0&id=1bb79840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb79840",
  null
  
)

export default component.exports